import { Component } from 'react';
import CommerceFilterIntent from '../../../../../components/CommerceFilterIntent';
import SearchVolume from './SearchVolume';

class ExtraBox extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <>
                <div className="table-additional-view  align-items-end">
                    <div className="table-additional-view-btns">
                        <CommerceFilterIntent
                            select={this.props.select}
                            handleSelectChange={this.props.handleSelectChange}
                        />
                    </div>
                    <div className="toggle-Invalid-items">
                        <SearchVolume
                            onFilter={this.props.onFilter}
                            data={this.props.data}
                            loading={this.props.loading}
                        />
                    </div>
                </div>
            </>
        );
    }
}

export default ExtraBox;
